
export function getEndpointUrl(endpoint:any, subpath:string=''):string {
    const { url='', protocol='http', host='', port=80 } = endpoint
    
    let _url = ''
    let _protocol = protocol

    if (url) {
        _url = url
    } else {
        const hosts = host.split('://')
        // host에 protocol을 포함한 경우
        if (hosts.length == 2) {
            const _host = hosts[1]
            _protocol = hosts[0]
            // host에 port를 포함한 경우
            const _hosts = _host.split(':')
            if (_hosts.length > 1) {
                _url = `${_hosts[0]}:${_hosts[1]}`
            } else {
                _url = `${_host}:${port}`
            }
        } else if (hosts.length == 1) { 
            _url = `${host}:${port}`
        }
    }

    return _protocol + '://' + _url.split('/').concat(subpath.split('/')).filter(x=>x).join('/')
}
